import React, { useEffect, useState } from 'react'
import './Order.css'
import moment from 'moment';
import CheckoutProduct from './CheckoutProduct';
import CurrencyFormat from "react-currency-format";
import { init } from 'emailjs-com';
init("user_sysI4tmJQHgscIKlmZAji");
import { db } from './firebase';
import { useStateValue } from './StateProvider';

function Order({ order }) {
    
    const [timing, setTiming] = useState([]);
    const [{user}] = useStateValue();

    useEffect(() => {
        fetchTiming();
    }, [])

    
    const fetchTiming = async()=>{
        const response = db.collection('Timing');
        const data = await response.get();
        data.docs.forEach(item=>{
            setTiming([...timing,item.data()])
           })
       
    };

    return (
        <div className='order'>
           
            <h2>Order</h2>
            <p>{moment.unix(order.data.created).format("MMMM Do YYYY, h:mma")}</p>
            <p>{user?.email}</p>
            <p className="order__id">
                <small>{order.id}</small>
            </p>
            
            <div className='cop'>
            {order.data.basket?.map(item => (
                <CheckoutProduct
                    id={item.id} 
                    title={item.title}
                    image={item.image}
                    price={item.price}
                    hideButton
                />
            ))}
            
            </div>
            <CurrencyFormat
                renderText={(value) => (
                    <h3 className="order__total">Order Total: {value}</h3>
                )}
                decimalScale={2}
                value={order.data.amount / 100}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"₹"}
            />  
        
        </div>
    )
}

export default Order
